import { useLocation } from "react-router-dom";
import { useState, useEffect, useRef } from "react";
import "./FPSMasterOrNot.css";
import axios from "axios";

const FPSMasterOrNot = () => {
    const location = useLocation();
    const [row, setRow] = useState(null);
    const [selectedCoords, setSelectedCoords] = useState(null);
    const [remarks, setRemarks] = useState(""); // ✅ Track remarks
    const [isLoggedIn, setIsLoggedIn] = useState(false);

    const [latitude, setLatitude] = useState('');
    const [longitude, setLongitude] = useState('');

    useEffect(() => {
        const storedData = localStorage.getItem("fpsMasterOrNot");
        if (storedData) {
            setRow(JSON.parse(storedData));
        }
    }, []);

    const [userInfo, setUserInfo] = useState({
        // displayName: '',
        // empId: ''
        fullName: '',
        employeeId: '',
        id: '',
        username: '',
    });
    useEffect(() => {
        const userData = JSON.parse(localStorage.getItem('user'));
        const loginTime = localStorage.getItem('loginTime');

        if (userData) {
            // Extract the first name from fullName (only the first word)
            const firstName = userData.fullName.split(' ')[0];

            // Set the state with firstName and employeeId
            setUserInfo({
                fullName: firstName,  // Only first name is considered
                employeeId: userData.employeeId,
                id: userData.id,
                loginUserName: userData.username,
            });
            setIsLoggedIn(true);
            // setLastLoginDateTime(`Last Login: ${format(new Date(loginTime), 'dd-MM-yyyy | hh:mm:ss a')}`);
        } else {
            setIsLoggedIn(false);
        }
    }, []);

    if (!row) {
        return <p className="no-data">No data found. Please go back to the table.</p>;
    }
    const capitalizeWords = (str) => {
        if (!str || typeof str !== "string") return "";
        return str
            .toLowerCase()
            .replace(/\b\w/g, (char) => char.toUpperCase());
    };



    const token = `${process.env.REACT_APP_AUTH_TOKEN}`;
    const baseUrl = `${process.env.REACT_APP_GODOWN_API_URL}/api`;
    // ✅ Handle Submit
    const handleSubmit = () => {
        if (!latitude || !longitude) {
            alert("Please enter both latitude and longitude.");
            return;
        }

        const payload = {
            userId: userInfo.id,
            fpsId: row.fpsId,

            // Use input values (instead of old master data)
            masterLatitude: latitude,
            masterLongitude: longitude,
        };

        console.log("Payload to send:", payload);

        axios.post(`${baseUrl}/update-fps-master-data`, payload, {
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
            },
        })
            .then(() => {
                alert("Updated Latitude and Longitude successfully!");
                window.close(); // Optional: close the window after success
            })
            .catch((error) => {
                console.error("Error adding Latitude and Longitude:", error);
                alert("Error adding Latitude and Longitude: " + error.message);
            });
    };



    return (
        <div className="photo-page">
            <h2 className="page-title">Master Data</h2>



            <div className="master-or-not">
                <div className="fps-id-based">
                    <div>FPS ID : </div>
                    <div>{row.fpsId}</div>
                </div>
                <div className="fps-id-based-1">
                    <div>Licence Number : </div>
                    <div>{row.licenceNumber}</div>
                </div>
                <div className="fps-based-id">
                    <div>Dealer Name :</div>
                    <div>{row.dealerName ? capitalizeWords(row.dealerName) : "-"}</div>

                </div>
            </div>

            <div className="master-or-not-selection">
                <div className="input-coordinates">Enter coordinates</div>
                <div className="inputs-lat-long">
                    <div className="inputs-lables-float">
                        <label>Latitude</label>
                        <input
                            className="latitude"
                            type="text"
                            placeholder="Enter Latitude"
                            value={latitude}
                            onChange={(e) => {
                                const value = e.target.value.replace(/[^0-9.-]/g, '');
                                setLatitude(value);
                            }}
                        />

                    </div>

                    <div className="inputs-lables-float">
                        <label>Longitude</label>
                        <input
                            className="latitude"
                            type="text"
                            placeholder="Enter Longitude"
                            value={longitude}
                            onChange={(e) => {
                                const value = e.target.value.replace(/[^0-9.-]/g, '');
                                setLongitude(value);
                            }}
                        />

                    </div>
                </div>


                {/* Buttons */}
                <div className="bottons-types">
                    <button
                        className="photo-submit"
                        type="button"
                        onClick={() => window.close()}
                    >
                        CANCEL
                    </button>
                    <button
                        className="photo-submit"
                        type="button"
                        onClick={handleSubmit}
                    >
                        SUBMIT
                    </button>
                </div>
            </div>


        </div>
    );
};
export default FPSMasterOrNot